export function customerSlugError(value: string): string | null {
  const slug = value.trim();
  if (Array.from(slug).length > 100) return "Use no more than 100 characters.";
  if (slug.includes("\u0000")) return "Null characters are not allowed.";
  return null;
}
